






























import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo: {
    title: 'Brought to you by',
    titleTemplate: '%s - Krišjānis Veinbahs',
  },
})
export default class Home extends Vue {
  isAdmin?: boolean | null

  isAuthenticated?: false | null

  error?: string | null

  data() {
    return {
      isAdmin: false,
      isAuthenticated: this.isAuthenticated || false,
      error: this.error || null,
    };
  }

  created() {
    this.checkAuthentication();
  }

  checkAuthentication() {
    this.error = null;
    this.isAuthenticated = false;
    fetch('/api/auth').then(response => response.json().then((status) => {
      this.isAuthenticated = status.isAuthenticated;
      this.isAdmin = status.isAdmin;
      this.error = null;
    }).catch((e) => {
      this.error = "Couldn't parse API server response.";
      this.isAuthenticated = false;
      this.isAdmin = false;
    })).catch((e) => {
      this.error = "Couldn't contact API server.";
      this.isAuthenticated = false;
      this.isAdmin = false;
    });
  }
}
